/*
  Kalessie - Quick View. Global event-delegated handler: any [data-kal-quick-view]
  button (on the Kalessie product card) opens a slide-up sheet with the product
  fetched via the Section Rendering API (/products/{handle}?section_id=quick-view).
  Variant selection updates price/availability; Add-to-cart reuses window.KalCart.add
  (assets/kalessie-cart.js) so Dawn's cart drawer/notification updates.
*/
(function () {
  var SHEET;

  function buildSheet() {
    if (SHEET) return SHEET;
    SHEET = document.createElement('div');
    SHEET.className = 'kal-qv-sheet';
    SHEET.hidden = true;
    SHEET.innerHTML =
      '<div class="kal-qv-sheet__backdrop" data-qv-close></div>' +
      '<div class="kal-qv-sheet__panel" role="dialog" aria-modal="true" aria-label="Quick view">' +
      '<div class="kal-qv-sheet__handle" data-qv-close aria-hidden="true"></div>' +
      '<button class="kal-qv-sheet__close" data-qv-close aria-label="Close">✕</button>' +
      '<div class="kal-qv-sheet__body"></div></div>';
    document.body.appendChild(SHEET);
    SHEET.querySelectorAll('[data-qv-close]').forEach(function (el) { el.addEventListener('click', closeSheet); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
    return SHEET;
  }
  function openSheet() { buildSheet().hidden = false; document.body.style.overflow = 'hidden'; }
  function closeSheet() {
    if (!SHEET) return;
    SHEET.hidden = true;
    SHEET.querySelector('.kal-qv-sheet__body').innerHTML = '';
    document.body.style.overflow = '';
  }

  function fetchProduct(handle) {
    var body = buildSheet().querySelector('.kal-qv-sheet__body');
    body.innerHTML = '<div class="kal-qv__loading">Loading…</div>';
    openSheet();
    fetch('/products/' + handle + '?section_id=quick-view', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('.kal-qv');
        if (content) { body.innerHTML = ''; body.appendChild(content); wire(content); }
        else { body.innerHTML = '<div class="kal-qv__loading">Could not load. <a href="/products/' + handle + '">View product →</a></div>'; }
      })
      .catch(function () { window.location = '/products/' + handle; });
  }

  function wire(root) {
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-qv-variants]').textContent); } catch (e) {}
    var addBtn = root.querySelector('[data-qv-add]');
    var priceEl = root.querySelector('[data-qv-price]');
    var optionEls = Array.prototype.slice.call(root.querySelectorAll('.kal-qv__option'));

    function selectedValues() {
      return optionEls.map(function (o) { var b = o.querySelector('.kal-qv__opt.is-selected'); return b ? b.getAttribute('data-value') : null; });
    }
    function findVariant(vals) {
      return variants.filter(function (v) { return v.options.length === vals.length && v.options.every(function (x, i) { return x === vals[i]; }); })[0];
    }
    function update() {
      var v = findVariant(selectedValues());
      if (!v || !addBtn) return;
      addBtn.setAttribute('data-variant-id', v.id);
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (priceEl) {
        priceEl.innerHTML = (v.compare && v.compare !== v.price)
          ? '<span class="kal-qv__price-sale">' + v.price + '</span> <s class="kal-qv__price-was">' + v.compare + '</s>'
          : v.price;
      }
    }
    root.querySelectorAll('.kal-qv__opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var grp = btn.closest('.kal-qv__option');
        grp.querySelectorAll('.kal-qv__opt').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        update();
      });
    });
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        var id = addBtn.getAttribute('data-variant-id');
        if (window.KalCart && window.KalCart.add) {
          window.KalCart.add(id, addBtn);
          setTimeout(closeSheet, 900);
        }
      });
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('[data-kal-quick-view]') : null;
    if (!trigger) return;
    e.preventDefault();
    var handle = trigger.getAttribute('data-kal-quick-view');
    if (handle) fetchProduct(handle);
  });
})();
